import * as actionTypes from './actionTypes';

export const fetchFavorites = () => ({
  type: actionTypes.FETCH,
});
export const fetchFavoritesSuccess = ids => ({
  type: actionTypes.FETCH_SUCCESS,
  ids,
});
export const fetchFavoritesError = error => ({
  type: actionTypes.FETCH_ERROR,
  error,
});

export const addFavorite = (entityType, entityId) => ({
  type: actionTypes.ADD_FAVORITE,
  entityType,
  entityId,
});
export const addFavoriteSuccess = id => ({
  type: actionTypes.ADD_FAVORITE_SUCCESS,
  id,
});
export const addFavoriteError = error => ({
  type: actionTypes.ADD_FAVORITE_ERROR,
  error,
});

export const removeFavorite = (entityType, entityId) => ({
  type: actionTypes.REMOVE_FAVORITE,
  entityType,
  entityId,
});
export const removeFavoriteSuccess = id => ({
  type: actionTypes.REMOVE_FAVORITE_SUCCESS,
  id,
});
export const removeFavoriteError = error => ({
  type: actionTypes.REMOVE_FAVORITE_ERROR,
  error,
});
